import { Link } from "react-router-dom";

import { styles } from "../styles";

export const QuickLink = ({
  path,
  name,
  icon,
  onClick,
}: {
  path?: string;
  name: string;
  icon: React.ReactNode;
  onClick?: () => void;
}) => {
  const getTabClassName = () => `${styles.tab.base} ${styles.tab.inactive}`;

  if (!path) {
    return (
      <div onClick={onClick} key={name} className={`${getTabClassName()} cursor-pointer`}>
        <span className="flex items-center">
          <span className="relative mr-2 h-5 max-h-5 w-5 max-w-5">{icon}</span>
          {name && name}
        </span>
      </div>
    );
  }

  return (
    <Link
      key={name}
      to={path}
      target="_blank"
      rel="noopener noreferrer"
      className={getTabClassName()}
    >
      <span className="flex items-center">
        <span className="relative mr-2 h-5 max-h-5 w-5 max-w-5">{icon}</span>
        {name && name}
      </span>
    </Link>
  );
};
